<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">

      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Add a new part</p>
          <button
            class="delete"
            aria-label="close"
            @click="close()">
          </button>
        </header>

        <v-form 
          class="modal-card-body" 
          :valid.sync="valid">

          <div class="columns">
            <div class="column">
              <label class="label">Part #*</label>
              <v-text-field 
                required
                placeholder="Enter Part Number"
                v-model="part.part_no">
              </v-text-field>
            </div>

            <div class="column">
              <label class="label">Length*</label>
              <v-text-field 
                required
                placeholder="Enter Length"
                v-model="part.length_in_str">
              </v-text-field>
            </div>

            <div class="column">
              <label class="label">Width*</label>
              <v-text-field 
                required
                placeholder="Enter Width"
                v-model="part.width_in_str">
              </v-text-field>
            </div>

            <div class="column">
              <label class="label">Quantity*</label>
              <v-text-field 
                required
                type="number"
                placeholder="Enter Quantity"
                v-model="part.quantity">
              </v-text-field>
            </div>
          </div>

          <div class="field">
            <label class="label">Shop Ticket</label>
            <v-drop-zone
              v-model="attachment.file"
              :file-name.sync="attachment.name"
              height="120px"
              id="part-file"/>
          </div>

          <div class="field">
            <label class="label">Cut Sheet Steps</label>
            <v-checkbox 
              v-for="step in part.steps"
              :key="step.id"
              v-model="step.is_required"
              :label="step.name"/>
          </div>

        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="addPart()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close()">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VTextField from '@/components/base/VTextField'
import VDropZone from '@/components/base/VDropZone'
import VCheckbox from '@/components/base/VCheckbox'

export default {
  components: { VForm, VTextField, VDropZone, VCheckbox },
  props: {
    value: {
      type: Boolean
    },
    cutSheetId: {
      type: [String, Number]
    },
    steps: {
      type: Array
    }
  },
  data() {
    return {
      valid: false,
      part: {
        part_no: null,
        length_in_str: null,
        width_in_str: null,
        quantity: null,
        steps: []
      },
      attachment: {
        file: null,
        name: null,
        url: null
      }
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.part.steps = JSON.parse(JSON.stringify(this.steps));
      this.part.steps.forEach(step => {
        step.is_required = step.required_by_default ? true : false;
      });
    },
    addPart() {
      let partCopy = Object.assign({}, this.part);

      partCopy.steps = partCopy.steps.filter(
        d => d.is_required == true
      ).map(d => { return { id: d.id }});

      this.$http.cutsheetParts.post(
        partCopy, 
        { cutsheet_id: this.cutSheetId }
      ).then(resp => {
        const { attachment } = this;

        if (this.attachment.file) {
          let formData = new FormData();
          formData.append('attachment', attachment.file, attachment.name);
          this.$http.cutsheetPart.addAttachment(resp.data.id, formData)
            .then(resp => {
              this.notifySuccess(resp);
            });
        } else {
          this.notifySuccess(resp);
        }
      })
    },
    notifySuccess(resp) {
      this.$emit("success", resp);
      this.close();
    },
    close() {
      this.$emit('input', false);
    }
  }
}
</script>


<style scoped>
</style>